import * as React from "react";
const SvgBasketHeader = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 15 14"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeWidth={1.2}
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M4.2876 3.79998H3.30947C2.26977 3.79998 1.75036 3.79998 1.38057 4.01209C1.05606 4.19823 0.806615 4.49225 0.676358 4.84294C0.528018 5.24232 0.613404 5.75464 0.784115 6.77891L0.784473 6.78084L1.53114 11.2608C1.6578 12.0208 1.72155 12.401 1.91117 12.6861C2.07833 12.9375 2.31296 13.1362 2.58838 13.2597C2.90082 13.3999 3.28589 13.4 4.05635 13.4H10.9191C11.6895 13.4 12.0743 13.3999 12.3868 13.2597C12.6622 13.1362 12.897 12.9375 13.0642 12.6861C13.2538 12.401 13.3172 12.0208 13.4438 11.2608L14.1905 6.78084L14.1912 6.77771C14.3618 5.75424 14.4472 5.24217 14.2989 4.84294C14.1686 4.49225 13.9198 4.19823 13.5953 4.01209C13.2255 3.79998 12.7052 3.79998 11.6655 3.79998H10.6876M4.2876 3.79998H10.6876M4.2876 3.79998C4.2876 2.03266 5.72029 0.599976 7.4876 0.599976C9.25491 0.599976 10.6876 2.03266 10.6876 3.79998"
    />
  </svg>
);
export default SvgBasketHeader;
